import * as go from 'gojs';
import { updateGroupBoundaries } from './group-bounds-utils';

export const groupOverrideDraggingTool = (diagram: go.Diagram, category: string) => {
  const tool = diagram.toolManager.draggingTool;
  overrideDragging(category, tool);
};

const overrideDragging = (groupCategory: string, tool: go.DraggingTool) => {
  const movePartsBase = tool.moveParts.bind(tool);
  const computeEffectiveCollectionBase = tool.computeEffectiveCollection.bind(tool);

  tool.moveParts = moveParts(tool, movePartsBase, groupCategory);
  tool.computeEffectiveCollection = computeEffectiveCollection(tool, computeEffectiveCollectionBase, groupCategory);
};

const computeEffectiveCollection =
  (
    tool: go.DraggingTool,
    computeEffectiveCollectionBase: (
      parts: go.Iterable<go.Part>,
      options: go.DraggingOptions,
    ) => go.Map<go.Part, go.DraggingInfo>,
    groupCategory: string,
  ) =>
  (parts: go.Iterable<go.Part>, options: go.DraggingOptions): go.Map<go.Part, go.DraggingInfo> => {
    const collection = computeEffectiveCollectionBase(parts, options);

    if (tool.currentPart?.category === groupCategory) {
      return collection;
    }

    const selectedGroupMembers = tool.diagram.selection.filter((s) => s.containingGroup?.category === groupCategory);

    const it = selectedGroupMembers.iterator;
    while (it.next()) {
      const group = it.value.containingGroup;
      if (!group) {
        continue;
      }

      const otherMembers = group.memberParts.filter((m) => !selectedGroupMembers.has(m));
      collection.remove(group);
      otherMembers.each((om) => collection.remove(om));
    }

    return collection;
  };

const moveParts =
  (
    tool: go.DraggingTool,
    movePartsBase: (parts: go.Map<go.Part, go.DraggingInfo>, offset: go.Point, check: boolean) => void,
    groupCategory: string,
  ) =>
  (parts: go.Map<go.Part, go.DraggingInfo>, offset: go.Point, check: boolean) => {
    const groupToUpdate = new Set<go.Group>();
    const iterator = parts.iterator;

    while (iterator.next()) {
      if (iterator.key.containingGroup?.category === groupCategory) {
        groupToUpdate.add(iterator.key.containingGroup);
      }
    }

    movePartsBase.call(tool, parts, offset, check);
    groupToUpdate.forEach((group) => updateGroupBoundaries(group));
  };
